import { Link } from "react-router-dom";
import { HOMEIQ_LOGO, VASTU_BY_HOMEIQ_LOGO } from "@/assets/brand";

export default function Footer() {
    return (
        <footer
            data-testid="site-footer"
            className="relative bg-white border-t border-[#0A1F44]/10 px-6 md:px-12 py-14"
        >
            <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
                <div className="flex items-center gap-5">
                    <img
                        src={HOMEIQ_LOGO}
                        alt="HomeIQ — Home Buying Intelligence"
                        data-testid="footer-logo-homeiq"
                        className="h-14 w-auto object-contain"
                    />
                    <div
                        aria-hidden="true"
                        className="hidden sm:block h-8 w-px bg-[#0A1F44]/15"
                    />
                    <img
                        src={VASTU_BY_HOMEIQ_LOGO}
                        alt="Vastu by HomeIQ"
                        data-testid="footer-logo-vastu"
                        className="hidden sm:block h-16 w-auto object-contain opacity-95"
                    />
                </div>

                <nav
                    aria-label="Footer"
                    className="flex flex-wrap gap-x-8 gap-y-3 text-[11px] tracking-[0.25em] uppercase text-[#0A1F44]/55 font-semibold"
                >
                    <Link
                        to="/privacy"
                        data-testid="footer-link-privacy"
                        className="hover:text-[#1E6BFF] transition-colors"
                    >
                        Privacy
                    </Link>
                    <Link
                        to="/terms"
                        data-testid="footer-link-terms"
                        className="hover:text-[#1E6BFF] transition-colors"
                    >
                        Terms
                    </Link>
                    <Link
                        to="/disclaimer"
                        data-testid="footer-link-disclaimer"
                        className="hover:text-[#1E6BFF] transition-colors"
                    >
                        Disclaimer
                    </Link>
                    <a
                        href="https://wa.me/917406054477"
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="footer-link-contact"
                        className="hover:text-[#1E6BFF] transition-colors"
                    >
                        Contact
                    </a>
                </nav>

                <div className="text-[11px] tracking-[0.25em] uppercase text-[#0A1F44]/45 font-medium">
                    © 2026 HomeIQ
                </div>
            </div>
        </footer>
    );
}
